/**
 * The page's location. Use it instead of `window.location`, which tests can't
 * replace: a reload or a new URL would take the test page with it.
 */
export const location: Location = window.location; // eslint-disable-line no-restricted-properties

export interface Location {
  readonly href: string;
  assign(url: string): void;
  reload(): void;
}
